/**
 * Layered Luxury Theme JS — Global utilities only.
 * Component-specific logic lives in its respective section/snippet.
 */

(function () {
  "use strict";

  const EASE = "cubic-bezier(0.2, 0.7, 0.2, 1)";

  /* =========================================================
     1. REVEAL ON SCROLL (IntersectionObserver)
     ========================================================= */
  function initReveals() {
    const revealEls = document.querySelectorAll(".lx-reveal, .lx-img-reveal");
    if (!revealEls.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -60px 0px", threshold: 0.1 },
    );

    revealEls.forEach((el) => observer.observe(el));
  }

  /* =========================================================
     2. HEADER SCROLL SHRINK + BLUR
     ========================================================= */
  function initHeaderScroll() {
    const header = document.querySelector(".header-wrapper");
    if (!header) return;

    const onScroll = () => {
      const y = window.scrollY || window.pageYOffset;
      if (y > 60) {
        header.classList.add("is-scrolled");
      } else {
        header.classList.remove("is-scrolled");
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* =========================================================
     3. CHECKOUT BUTTON LOADING SPINNER
     ========================================================= */
  function initCheckoutSpinner() {
    // Delegated so it survives cart / cart-drawer HTML re-renders.
    document.addEventListener("click", (event) => {
      const button = event.target.closest('button[name="checkout"]');
      if (!button || button.disabled || button.getAttribute("aria-disabled") === "true") return;

      button.classList.add("loading");
      const spinner = button.querySelector(".loading__spinner");
      if (spinner) spinner.classList.remove("hidden");
    });

    // Reset if the page is restored from the back/forward cache while spinning.
    window.addEventListener("pageshow", () => {
      document.querySelectorAll('button[name="checkout"].loading').forEach((button) => {
        button.classList.remove("loading");
        const spinner = button.querySelector(".loading__spinner");
        if (spinner) spinner.classList.add("hidden");
      });
    });
  }

  /* =========================================================
     4. PAGE TRANSITION FADE
     ========================================================= */
  function initPageTransitions() {
    window.addEventListener("pagehide", () => {
      document.body.style.opacity = "0";
      document.body.style.transition = "opacity 200ms " + EASE;
    });
    window.addEventListener("pageshow", () => {
      document.body.style.opacity = "1";
    });
  }

  /* =========================================================
     INITIALISE
     ========================================================= */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initReveals();
      initHeaderScroll();
      initCheckoutSpinner();
      initPageTransitions();
    });
  } else {
    initReveals();
    initHeaderScroll();
    initCheckoutSpinner();
    initPageTransitions();
  }
})();
